import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Clients
export const listClients = (search = "") => api.get("/clients", { params: search ? { search } : {} }).then(r => r.data);
export const getClient = (id) => api.get(`/clients/${id}`).then(r => r.data);
export const createClient = (data) => api.post("/clients", data).then(r => r.data);
export const updateClient = (id, data) => api.put(`/clients/${id}`, data).then(r => r.data);
export const deleteClient = (id) => api.delete(`/clients/${id}`).then(r => r.data);

// Tattoos
export const listTattoos = (params = {}) => api.get("/tattoos", { params }).then(r => r.data);
export const createTattoo = (data) => api.post("/tattoos", data).then(r => r.data);
export const updateTattoo = (id, data) => api.put(`/tattoos/${id}`, data).then(r => r.data);
export const deleteTattoo = (id) => api.delete(`/tattoos/${id}`).then(r => r.data);
export const updateTattooFollowup = (id, status) => api.put(`/tattoos/${id}/followup`, { status }).then(r => r.data);

// Lucky numbers
export const listLuckyNumbers = (client_id) => api.get("/lucky-numbers", { params: client_id ? { client_id } : {} }).then(r => r.data);
export const nextLuckyNumber = () => api.get("/lucky-numbers/next").then(r => r.data);
export const createLuckyNumber = (data) => api.post("/lucky-numbers", data).then(r => r.data);
export const deleteLuckyNumber = (id) => api.delete(`/lucky-numbers/${id}`).then(r => r.data);

// Draws
export const performDraw = (prize) => api.post("/draws/perform", { prize }).then(r => r.data);
export const listDraws = () => api.get("/draws").then(r => r.data);
export const deleteDraw = (id) => api.delete(`/draws/${id}`).then(r => r.data);

// Reminders
export const listReminders = (params = {}) => api.get("/reminders", { params }).then(r => r.data);
export const createReminder = (data) => api.post("/reminders", data).then(r => r.data);
export const updateReminder = (id, data) => api.put(`/reminders/${id}`, data).then(r => r.data);
export const deleteReminder = (id) => api.delete(`/reminders/${id}`).then(r => r.data);

// Post-care
export const listPostCare = (days = 7) => api.get("/post-care", { params: { days } }).then(r => r.data);

// Dashboard / Financial / Insights
export const getDashboard = () => api.get("/dashboard").then(r => r.data);
export const getFinancialReport = (year) => api.get("/financial/report", { params: year ? { year } : {} }).then(r => r.data);
export const getInsights = () => api.get("/insights").then(r => r.data);
export const financialCsvUrl = ({ year, month } = {}) => {
  const params = new URLSearchParams();
  if (month) params.set("month", month);
  else if (year) params.set("year", year);
  return `${API}/financial/export.csv?${params.toString()}`;
};

// Backup
export const exportBackup = () => api.get("/backup/export").then(r => r.data);
export const importBackup = (payload, replace = false) =>
  api.post("/backup/import", payload, { params: { replace } }).then(r => r.data);

// Public ranking
export const publicRanking = () => api.get("/public/ranking").then(r => r.data);

// Settings (Care PDF)
export const getSettings = () => api.get("/settings").then(r => r.data);
export const uploadCarePdf = (data_base64, filename) =>
  api.post("/settings/care-pdf", { data_base64, filename }).then(r => r.data);
export const deleteCarePdf = () => api.delete("/settings/care-pdf").then(r => r.data);
export const carePdfPublicUrl = () => `${API}/public/care-pdf`;
export const updateMessageTemplates = (templates) => api.put("/settings/messages", templates).then(r => r.data);
